import Vue from 'vue';
import Vuex from 'vuex';
import {storeKey} from '../constants/common';

Vue.use(Vuex);

let store = new Vuex.Store({
  state:{

  },
  mutations:{
    LOGIN(state,result){
      state.userInfo = result;
      state.userInfoFibo = result;
      console.log('store:',state);
      save(state);
    },
    GET_INFO(state,result){
      let stored = JSON.parse(localStorage.getItem(storeKey)),
        {accessToken} = stored.userInfo;
       state.userInfo = {
        unionid:result.unionid,
        openid:result.openid,
        cardType:result.cardType,
        received:result.received,
        accessToken:accessToken,
        cardId:result.cardId,
        code:result.code
      }
      state.userInfoFibo = stored.userInfoFibo || {}
      stored.cardInfo&&(state.cardInfo = stored.cardInfo);
      stored.cardDetail&&(state.cardDetail = stored.cardDetail);
      console.log('store:',state);
      save(state);
    },
    RECORD_CARD(state,result){
      state.cardInfo = result;
      state.cardDetail = JSON.parse(result.cardExt);
      save(state);
    },
  }
})


function save(state){
  store.replaceState(state);
  localStorage.setItem(storeKey,JSON.stringify(state));
}

export default store;